(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anvil-product-choice-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loader = document.querySelector('[data-anvil-preset-loader]');
    if (!loader) return;

    const presets = new Set(['black-red', 'black-light-grey', 'black-dark-grey', 'plastic-pink', 'dark-grey']);
    let watchTimer;
    let fallbackTimer;
    let hideTimer;

    const readPreset = (value) => {
      try {
        return new URL(value, window.location.href).searchParams.get('abd_preset');
      } catch (error) {
        return '';
      }
    };

    const hideLoader = () => {
      window.clearInterval(watchTimer);
      window.clearTimeout(fallbackTimer);
      loader.classList.remove('is-active');
      hideTimer = window.setTimeout(() => {
        loader.hidden = true;
      }, 180);
    };

    const watchForDesigner = () => {
      window.clearInterval(watchTimer);
      window.clearTimeout(fallbackTimer);
      watchTimer = window.setInterval(() => {
        if (document.querySelector('.abd-overlay--open')) hideLoader();
      }, 80);
      fallbackTimer = window.setTimeout(hideLoader, 12000);
    };

    const showLoader = () => {
      window.clearTimeout(hideTimer);
      loader.hidden = false;
      window.requestAnimationFrame(() => loader.classList.add('is-active'));
      watchForDesigner();
    };

    const handlePresetIntent = (event) => {
      if ((typeof event.button === 'number' && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target && event.target.closest
        ? event.target.closest('[data-anvil-preset-launch]')
        : null;
      if (!link) return;
      const preset = readPreset(link.href);
      if (!presets.has(preset)) return;
      showLoader();

      if (event.type !== 'click') return;
      // A fresh powerlifting designer instance keeps each card's starting point isolated.
      if (link.hasAttribute('data-anvil-preset-reload')) return;

      let presetUrl;
      try {
        presetUrl = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }
      if (presetUrl.origin !== window.location.origin || presetUrl.pathname !== window.location.pathname) return;

      event.preventDefault();
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('abd_edit');
      currentUrl.searchParams.set('abd_preset', preset);
      window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);

      const designerButton = document.querySelector('#anvil-belt-designer .abd-cta');
      if (designerButton && !designerButton.disabled) {
        designerButton.click();
      } else {
        window.location.assign(link.href);
      }
    };

    document.addEventListener('pointerdown', handlePresetIntent, true);
    document.addEventListener('click', handlePresetIntent, true);

    if (presets.has(readPreset(window.location.href))) showLoader();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews-new"] && !Shopify.designMode) return;
  try {
    
const initAnvilReviewCarousels = () => {
  document.querySelectorAll('[data-ah-reviews-carousel]').forEach((root) => {
    if (root.dataset.ahReviewsReady === 'true') return;
    const track = root.querySelector('[data-ah-reviews-track]');
    const prev = root.querySelector('[data-ah-reviews-prev]');
    const next = root.querySelector('[data-ah-reviews-next]');
    const dotsWrap = root.querySelector('[data-ah-reviews-dots]');
    if (!track) return;
    root.dataset.ahReviewsReady = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const originalCards = Array.from(track.children);
    const originalCount = originalCards.length;
    let autoTimer;
    let resumeTimer;
    let paused = false;
    let cycleWidth = 0;
    let activeDotIndex = -1;
    originalCards.forEach((card, index) => {
      card.dataset.ahReviewIndex = index.toString();
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('ah-rev--clone');
      track.appendChild(clone);
    });
    const dots = [];
    if (dotsWrap) {
      originalCards.forEach((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ah-reviews-dot';
        dot.setAttribute('aria-label', `Show review ${index + 1} of ${originalCount}`);
        dot.addEventListener('click', () => {
          pauseAfterUse();
          scrollToIndex(index);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    const getStep = () => {
      const card = track.querySelector('.ah-rev');
      if (!card) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    };
    const measure = () => {
      const firstClone = track.children[originalCount];
      cycleWidth = firstClone ? firstClone.offsetLeft - originalCards[0].offsetLeft : track.scrollWidth / 2;
    };
    const getMaxScroll = () => track.scrollWidth - track.clientWidth;
    const updateDots = () => {
      if (!dots.length) return;
      const step = getStep();
      if (!step) return;
      const wrappedLeft = cycleWidth ? track.scrollLeft % cycleWidth : track.scrollLeft;
      const nextIndex = Math.round(wrappedLeft / step) % originalCount;
      if (nextIndex === activeDotIndex) return;
      activeDotIndex = nextIndex;
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === nextIndex);
        if (index === nextIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };
    const stopAuto = () => {
      track.classList.remove('is-auto-scrolling');
      window.clearInterval(autoTimer);
      autoTimer = null;
    };
    const scrollToIndex = (index) => {
      measure();
      const currentCycle = cycleWidth ? Math.floor(track.scrollLeft / cycleWidth) : 0;
      const target = currentCycle * cycleWidth + originalCards[index].offsetLeft;
      track.scrollTo({ left: target, behavior: 'smooth' });
      window.setTimeout(updateDots, 500);
    };
    const go = (direction) => {
      track.classList.remove('is-auto-scrolling');
      const maxScroll = getMaxScroll();
      if (maxScroll <= 1) return;
      if (cycleWidth > 0 && direction > 0 && track.scrollLeft >= cycleWidth - getStep()) {
        track.scrollLeft -= cycleWidth;
      }
      if (cycleWidth > 0 && direction < 0 && track.scrollLeft <= 8) {
        track.scrollLeft += cycleWidth;
      }
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
      window.setTimeout(updateDots, 500);
    };
    const startAuto = () => {
      if (reduceMotion) return;
      stopAuto();
      paused = false;
      measure();
      track.classList.add('is-auto-scrolling');
      autoTimer = window.setInterval(() => {
        if (cycleWidth <= 0) measure();
        if (!paused && cycleWidth > 0) {
          track.scrollLeft += 1;
          if (track.scrollLeft >= cycleWidth) track.scrollLeft -= cycleWidth;
          updateDots();
        }
      }, 45);
    };
    function pauseAfterUse() {
      paused = true;
      stopAuto();
      window.clearTimeout(resumeTimer);
      if (!reduceMotion) resumeTimer = window.setTimeout(startAuto, 8000);
    }
    if (prev) prev.addEventListener('click', () => {
      pauseAfterUse();
      go(-1);
    });
    if (next) next.addEventListener('click', () => {
      pauseAfterUse();
      go(1);
    });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((eventName) => {
      track.addEventListener(eventName, pauseAfterUse, { passive: true });
    });
    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', () => {
      measure();
      updateDots();
    });
    measure();
    updateDots();
    startAuto();
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnvilReviewCarousels);
} else {
  initAnvilReviewCarousels();
}
document.addEventListener('shopify:section:load', initAnvilReviewCarousels);

  } catch(e) { console.error(e); }
})();
})();
